import { gql } from '@apollo/client';
import { AUCTION_DETAIL_RESPONSE_BODY } from './auctions';

export const ALL_BIDS_QUERY_NAME = 'AllBids';
export const ALL_BIDS = gql`
    query ${ALL_BIDS_QUERY_NAME}($auctionId: Int!) {
        allBids(auctionId: $auctionId) {
            auctionMembers {
                totalCount
                models {
                    name
                    memberId
                    auctionLimit
                    suspended
                    users {
                        racf
                        userCode
                        name
                        permissions
                    }
                }
            }
            bidList {
                models {
                    id
                    quantity
                    price
                    quantityAllocated
                    randomlyAllocated
                    asBrokerReference
                    winner
                    lastModUser
                    lastModTime
                    creationTime
                    volume
                    cancelled
                    cancellationReason
                    obfuscated
                    rank
                    fromVisibleMember
                    member {
                        memberId
                        balancingGroup
                        paymentCurrency {
                            exchangeRate
                            code
                        }
                    }
                    user {
                        userCode
                        racf
                        name
                        permissions
                    }
                }
            }
            auctionDetail {
                ${AUCTION_DETAIL_RESPONSE_BODY}
            }
        }
    }
`;

export const SUBMIT_BID = gql`
    mutation SubmitBid(
        $auctionId: Int!, 
        $memberId: String!, 
        $userRacf: String!, 
        $quantity: Int!, 
        $price: Price!,
        $correlationId: String!, 
        $asBrokerReference: String, 
        $fourEyesUserId: String, 
        $fourEyesPassword: String
    ) {
        submitBid(
            auctionId: $auctionId, 
            memberId: $memberId, 
            userRacf: $userRacf, 
            quantity: $quantity, 
            price: $price, 
            correlationId: $correlationId, 
            asBrokerReference: $asBrokerReference, 
            fourEyesUserId: $fourEyesUserId, 
            fourEyesPassword: $fourEyesPassword
        ) {
            models {
                id
            }
        }
    }
`;

export const SUBMIT_SLOTTED_BIDS = gql`
    mutation SubmitSlottedBids(
        $auctionId: Int!, 
        $memberId: String!, 
        $userRacf: String!, 
        $prices: [Price!],
        $correlationId: String!, 
        $asBrokerReference: String, 
        $fourEyesUserId: String, 
        $fourEyesPassword: String 
    ) {
        submitSlottedBids(
            auctionId: $auctionId, 
            memberId: $memberId, 
            userRacf: $userRacf, 
            prices: $prices, 
            correlationId: $correlationId, 
            asBrokerReference: $asBrokerReference, 
            fourEyesUserId: $fourEyesUserId, 
            fourEyesPassword: $fourEyesPassword 
        ) {
            models {
                id
            }
        }
    }
`;

export const CANCEL_BIDS = gql`
    mutation CancelBids(
        $bidIds: [Int!], 
        $correlationId: String!, 
        $fourEyesUserId: String, 
        $fourEyesPassword: String
    ) {
        cancelBids(
            bidIds: $bidIds, 
            correlationId: $correlationId, 
            fourEyesUserId: $fourEyesUserId, 
            fourEyesPassword: $fourEyesPassword
        ) {
            cancelledCount
        }
    }
`;

export const MODIFY_BIDS = gql`
    mutation ModifyBids(
        $bidModifications: [ModifyBidInputInput!], 
        $correlationId: String!, 
        $fourEyesUserId: String, 
        $fourEyesPassword: String
    ) {
        modifyBids(
            bidModifications: $bidModifications, 
            correlationId: $correlationId, 
            fourEyesUserId: $fourEyesUserId, 
            fourEyesPassword: $fourEyesPassword 
        ) {
            modifiedCount
        }
    }
`;

export const ON_BID_CHANGED = gql`
    subscription onBidChanged($auctionId: Int!) {
        bidChanged(auctionId: $auctionId) {
            correlationId
            action
            model {
                models {
                    id
                }
            }
        }
    }
`;
